export default "__VITE_ASSET__LQkmPlpc__"